import { hookstate } from "@hookstate/core";

import { ILojaState } from "./simulacao/loja";
import { IPropostaState } from "./simulacao/proposta";
import { ISimulacaoState } from "./simulacao/simulacao";

const globalState = hookstate({
    isLoading: true
} as {
    isLoading: boolean
    faseLoja: ILojaState
    faseProposta: IPropostaState
    simulacao: ISimulacaoState
});

export default globalState;